<template>
  <div class="channels-management-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入频道" size="small" class="param-input" ></el-input>
      <el-button type="primary" size="small" @click="getGoldList()">搜索</el-button>
      <el-button type="primary" size="small" @click="channelsAction('add')">+ 新增频道</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableDate"  style="width: 100%" border  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="name" label="ID" align="center" fixed></el-table-column>
      <el-table-column prop="name" label="频道排序" align="center"></el-table-column>
      <el-table-column prop="name" label="频道名称" align="center"></el-table-column>
      <el-table-column prop="name" label="影片数量" align="center"></el-table-column>
      <el-table-column prop="name" label="访问量" align="center"></el-table-column>
      <el-table-column prop="name" label="推荐影片" align="center">

      </el-table-column>
      <el-table-column prop="name" label="增加日期" align="center">
        <template slot-scope="scope">
          {{scope.row.startTime | changeDate}}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="修改日期" align="center">
        <template slot-scope="scope">
          {{scope.row.startTime | changeDate}}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status"></el-switch>
        </template>
      </el-table-column>

       <el-table-column label="操作" align="center" fixed="right" width="250">
        <template slot-scope="scope">
          <div class="operating-box">
            <div class="row-top">
              <el-button type="success" size="mini" @click="channelsAction('edit',scope.row)">编辑</el-button>
              <el-button type="primary" size="mini">上移</el-button>
              <el-button type="primary" size="mini">置顶</el-button>
            </div>
            <div class="row-bottom">
              <el-button type="danger" size="mini">删除</el-button>
              <el-button type="primary" size="mini">下移</el-button>
              <el-button type="primary" size="mini">最底</el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!-- 编辑弹窗 -->
    <channels-action ref="channelsAction"></channels-action>
  </div>
</template>
<script>
import baseConfig from '@/utils/serverUrlConfig'
import ChannelsAction from './components/channelsAction'
import API from '@/api'
export default {
  data() {
    return {
      loading: false,
      tableDate: [1],
      total: 0,
      time: '',
      // 女优列表状态
      statusList:[
        {
          label: '全部',
          value: 1
        },
        {
          label: '开启',
          value: 2
        },
        {
          label: '关闭',
          value: 3
        }
      ],
      imgUrl: baseConfig.imgUrl,
      params: {
        pageNumber: 1,
        pageSize: 10,
        turnOn :false,
        enable: ''
      }
    }
  },
  created() {
    // this.getRankList()
  },
  components: {
    ChannelsAction
  },
  methods: {
    // 请求排行列表数据
    getRankList() {
      this.loading = true
      API.getRankList(this.params).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
     // 监听编辑成功过后重新拉去数据
    handlerRankList() {
      this.param.pageNumber = 1
      this.param.pageSize = 10
      this.getRankList()
    },
    
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getRankList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getRankList()
    },
    // 新增/编辑频道弹窗
     channelsAction(type,row) {
      this.$refs.channelsAction.open(type,row)
    },
  }
}
</script>
<style scoped lang="scss">
  .operating-box {
    .row-top {
      margin-bottom: 10px;
    }
  }
</style>
